import React, { useEffect, useState } from 'react';
import styles from './RevokeToasts.module.scss';
import { apiHolder as api, apis } from 'api';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import IconCard from '@web-common/components/UI/IconCard';
import RevokeCountDown from '@web-mail/components/RevokeCountDown/RevokeCountDown';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { openMailInWinow, reOpenMail } from '@web-mail/util';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.api.getSystemApi();
const RevokeToasts = React.forwardRef(() => {
    const [sendingMailLen, setSendingMailLen] = useState(0);
    const { sendingMails } = useAppSelector(state => state.mailReducer);
    const dispatch = useAppDispatch();
    const revoke = async (item) => {
        var _a;
        trackApi.track('pcMail_click_button_cancelSendMailToast', { buttonName: '撤销发送' });
        const { id, tid, sentTInfo, optSenderStr } = item;
        dispatch(mailActions.doRemoveSendingMail(id));
        try {
            const cancelRes = await mailApi.doCancelDeliver({
                tid,
                tinfo: sentTInfo,
                mailTrace: true,
                _account: ((_a = systemApi.getCurrentUser(optSenderStr || '')) === null || _a === void 0 ? void 0 : _a.id) || '',
            });
            if (!cancelRes.success) {
                return;
            }
            reOpenMail(item);
        }
        catch (error) {
            console.log('撤销失败', error);
        }
    };
    const checkMail = async (item) => {
        trackApi.track('pcMail_click_button_cancelSendMailToast', { buttonName: '查看邮件' });
        const { id, optSenderStr } = item;
        openMailInWinow({ id, _account: optSenderStr });
    };
    const sendImmediately = async (item) => {
        const { id, sentTInfo, optSenderStr } = item;
        dispatch(mailActions.doRemoveSendingMail(id));
        try {
            const sendRes = await mailApi.doImmediateDeliver({ tinfo: sentTInfo, _account: optSenderStr });
            if (sendRes.success) {
                SiriusMessage.success({ content: '立即发送成功' });
            }
            else {
                SiriusMessage.error({ content: '立即发送失败' });
            }
        }
        catch (error) {
            console.log('立即发送失败', error);
        }
    };
    const closeToast = (closeId) => {
        trackApi.track('pcMail_click_button_cancelSendMailToast', { buttonName: '关闭' });
        const newSendingMails = sendingMails.map(item => {
            const { id } = item;
            if (id === closeId) {
                return Object.assign(Object.assign({}, item), { toastShow: false });
            }
            return item;
        });
        dispatch(mailActions.doUpdateSendingMails(newSendingMails));
    };
    useEffect(() => {
        if (sendingMails.length > sendingMailLen) {
            trackApi.track('pcMail_show_cancelSendMailToast', {});
        }
        setSendingMailLen(sendingMails.length);
    }, [sendingMails.length]);
    return (React.createElement("div", { className: styles.revokeToasts }, sendingMails.map(item => {
        return (React.createElement(React.Fragment, null, item.toastShow !== false && (React.createElement("div", { className: styles.revokeToast },
            React.createElement(RevokeCountDown, { id: item.id, createTime: item.createTime, attrs: {
                    strokeColor: '#94A6FF',
                    strokeLinecap: 'butt',
                    trailColor: 'white',
                    strokeWidth: 7.5,
                    width: 21,
                }, leftSecStyle: {
                    fontWeight: 400,
                    fontSize: '12px',
                    color: 'white',
                } }),
            React.createElement("span", null, "\u53D1\u9001\u4E2D"),
            React.createElement("div", { className: styles.revoke, onClick: () => revoke(item) }, getIn18Text('CHEXIAO')),
            React.createElement("div", { className: styles.checkMail, onClick: () => checkMail(item) }, getIn18Text('CHAKANYOUJIAN')),
            React.createElement("div", { className: styles.sendImmediately, onClick: () => sendImmediately(item) }, getIn18Text('LIJIFASONG')),
            React.createElement(IconCard, { type: "close", style: { cursor: 'pointer' }, strokeStyle: { stroke: 'white' }, onClick: () => closeToast(item.id) })))));
    })));
});
export default RevokeToasts;
